<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-barcode" titulo="SEPARACAO DE PEDIDOS">
      <template #subtitulo>
        <i class="fa fa-clock-o mr-1 text-info"></i>
        Aguardando: <strong class="text-white">{{ contarStatus('7') }}</strong>
        <span class="mx-2">|</span>
        <i class="fa fa-play mr-1 text-warning"></i>
        Em separacao: <strong class="text-white">{{ contarStatus('8') }}</strong>
      </template>

      <template #acoes>
        <b-button variant="link" class="btn-glass btn-glass-primary" @click="carregarPedidos" :disabled="carregando">
          <i class="fa fa-refresh mr-1" :class="{'fa-spin': carregando}"></i> Atualizar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="page-main px-3">
      <b-row class="mb-3">
        <b-col sm="3">
          <b-card no-body class="border-0 shadow-sm rounded-lg h-100">
            <b-card-body class="py-3">
              <small class="text-muted font-weight-bold">Total na Fila</small>
              <h3 class="mb-0 text-primary font-weight-bold">{{ pedidos.length }}</h3>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="3">
          <b-card no-body class="border-0 shadow-sm rounded-lg h-100">
            <b-card-body class="py-3">
              <small class="text-muted font-weight-bold">Aguardando Separacao</small>
              <h3 class="mb-0 text-success font-weight-bold">{{ contarStatus('7') }}</h3>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="3">
          <b-card no-body class="border-0 shadow-sm rounded-lg h-100">
            <b-card-body class="py-3">
              <small class="text-muted font-weight-bold">Em Separacao</small>
              <h3 class="mb-0 text-warning font-weight-bold">{{ contarStatus('8') }}</h3>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="3">
          <b-card no-body class="border-0 shadow-sm rounded-lg h-100">
            <b-card-body class="py-3">
              <small class="text-muted font-weight-bold">Peso Separado</small>
              <h3 class="mb-0 text-info font-weight-bold">{{ formatarQuant(totalSeparado) }}</h3>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-card no-body class="border-0 shadow-sm rounded-lg">
        <div class="p-3 bg-white border-bottom d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
          <div class="d-flex align-items-center mb-2 mb-lg-0">
            <i class="fa fa-list text-primary mr-2"></i>
            <h5 class="mb-0 text-primary font-weight-bold">Fila do Estoque</h5>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <b-form-input
              v-model="filtro"
              size="sm"
              class="rounded-pill mr-2 mb-2 mb-lg-0"
              style="min-width: 260px"
              placeholder="Filtrar por pedido, cliente ou vendedor..."
              @input="aplicarFiltros"
            />
            <b-button-group size="sm">
              <b-button :variant="statusFiltro === null ? 'primary' : 'outline-primary'" @click="setStatus(null)">Todos</b-button>
              <b-button :variant="statusFiltro === '7' ? 'success' : 'outline-success'" @click="setStatus('7')">Aguardando</b-button>
              <b-button :variant="statusFiltro === '8' ? 'warning' : 'outline-warning'" @click="setStatus('8')">Em Separacao</b-button>
            </b-button-group>
          </div>
        </div>

        <b-table
          ref="tbl"
          :items="pedidosFiltrados"
          :fields="fields"
          :busy.sync="carregando"
          hover
          small
          responsive
          show-empty
          empty-text="Nenhum pedido aguardando separacao"
          class="mb-0"
          @row-clicked="selecionarPedido"
          :tbody-tr-class="rowClass"
        >
          <template #cell(SEQUENCIA)="row">
            <strong class="text-primary">#{{ row.item.SEQUENCIA }}</strong>
          </template>

          <template #cell(NOME_CLIENTE)="row">
            <div class="font-weight-bold">{{ row.item.NOME_CLIENTE || '-' }}</div>
            <small class="text-muted">{{ row.item.NOME_VENDEDOR || '' }}</small>
          </template>

          <template #cell(SITUACAO)="row">
            <b-badge pill :variant="row.item.SITUACAO === '7' ? 'success' : 'warning'">
              {{ row.item.SITUACAO === '7' ? 'AGUARDANDO SEPARACAO' : 'EM SEPARACAO' }}
            </b-badge>
          </template>

          <template #cell(PESO_PEDIDO)="row">
            <span class="font-weight-bold">{{ formatarQuant(row.item.PESO_PEDIDO) }}</span>
          </template>

          <template #cell(PESO_CONFERIDO)="row">
            <span class="font-weight-bold text-info">{{ formatarQuant(row.item.PESO_CONFERIDO) }}</span>
          </template>

          <template #cell(PROGRESSO)="row">
            <div class="d-flex align-items-center">
              <b-progress
                :value="calcularProgresso(row.item)"
                :max="100"
                height="8px"
                class="flex-grow-1 mr-2"
                :variant="calcularProgresso(row.item) >= 100 ? 'success' : 'info'"
              />
              <small class="text-muted font-weight-bold">{{ calcularProgresso(row.item) }}%</small>
            </div>
          </template>

          <template #cell(actions)="row">
            <div class="d-flex justify-content-end align-items-center">
              <b-button
                v-if="row.item.SITUACAO === '7'"
                size="sm"
                variant="success"
                class="rounded-pill px-3 font-weight-bold mr-1"
                @click.stop.prevent="iniciarOuContinuar(row.item)"
              >
                <i class="fa fa-play mr-1"></i> Play
              </b-button>
              <b-button
                v-else
                size="sm"
                variant="warning"
                class="rounded-pill px-3 font-weight-bold mr-1"
                @click.stop.prevent="iniciarOuContinuar(row.item)"
              >
                <i class="fa fa-pencil mr-1"></i> Continuar
              </b-button>
              <b-button
                size="sm"
                variant="outline-danger"
                class="rounded-circle"
                title="Devolver para o Vendedor"
                :disabled="!podeDevolver(row.item)"
                @click.stop.prevent="devolverPedido(row.item)"
                v-b-tooltip.hover.left
              >
                <i class="fa fa-undo"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </b-card>
    </div>

    <ConferenciaVendasModal
      ref="terminalModal"
      :pedido-id="selectedPedidoId"
      @concluido="carregarPedidos"
    />
  </div>
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import ConferenciaVendasModal from '@/views/expedicao/conferencia/ConferenciaVendasModal.vue'
import Tools from '@/tools/tools.js'

export default {
  name: 'PedidoVendaSeparacaoWeb',
  components: {
    HeaderPadrao,
    ConferenciaVendasModal
  },
  data () {
    return {
      carregando: false,
      pedidos: [],
      pedidosFiltrados: [],
      selectedPedidoId: null,
      filtro: '',
      statusFiltro: null,
      fields: [
        { key: 'SEQUENCIA', label: 'Pedido', sortable: true },
        { key: 'DT_SOLICITA_CONFERENCIA', label: 'Solicitacao', sortable: true, formatter: this.formatarData },
        { key: 'NOME_CLIENTE', label: 'Cliente / Vendedor', sortable: true },
        { key: 'SITUACAO', label: 'Status', class: 'text-center' },
        { key: 'PESO_PEDIDO', label: 'Peso Pedido', class: 'text-right' },
        { key: 'PESO_CONFERIDO', label: 'Separado', class: 'text-right' },
        { key: 'PROGRESSO', label: 'Progresso' },
        { key: 'actions', label: 'Acoes', class: 'text-right', thStyle: { width: '220px' } }
      ]
    }
  },
  computed: {
    totalSeparado () {
      return this.pedidos.reduce((total, pedido) => total + Number(pedido.PESO_CONFERIDO || 0), 0)
    }
  },
  mounted () {
    this.carregarPedidos()
  },
  methods: {
    async carregarPedidos () {
      this.carregando = true
      try {
        const result = await this.$http.get('/api/protected/separacao-vendas/pedidos-elegiveis')
        this.pedidos = result.data || []
        this.aplicarFiltros()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err || 'Nao foi possivel listar a fila de separacao')
      } finally {
        this.carregando = false
      }
    },
    aplicarFiltros () {
      const texto = String(this.filtro || '').toLowerCase().trim()
      let lista = [...this.pedidos]
      if (this.statusFiltro) lista = lista.filter(item => String(item.SITUACAO || '').trim() === this.statusFiltro)
      if (texto) {
        lista = lista.filter(item =>
          String(item.SEQUENCIA || '').includes(texto) ||
          String(item.NOME_CLIENTE || '').toLowerCase().includes(texto) ||
          String(item.NOME_VENDEDOR || '').toLowerCase().includes(texto)
        )
      }
      this.pedidosFiltrados = lista
    },
    setStatus (status) {
      this.statusFiltro = this.statusFiltro === status ? null : status
      this.aplicarFiltros()
    },
    contarStatus (status) {
      return this.pedidos.filter(item => String(item.SITUACAO || '').trim() === status).length
    },
    calcularProgresso (pedido) {
      const pedidoPeso = Number(pedido.PESO_PEDIDO || 0)
      const separado = Number(pedido.PESO_CONFERIDO || 0)
      if (!pedidoPeso) return 0
      return Math.min(100, Math.round((separado / pedidoPeso) * 100))
    },
    async iniciarOuContinuar (pedido) {
      this.selectedPedidoId = pedido.SEQUENCIA
      try {
        if (String(pedido.SITUACAO || '').trim() === '7') {
          await this.$http.post('/api/protected/separacao-vendas/iniciar', {
            pedidoId: pedido.SEQUENCIA,
            usuario: window.localStorage.getItem('login')
          })
          this.$set(pedido, 'SITUACAO', '8')
        }
        this.$nextTick(() => this.$refs.terminalModal.abrir())
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err || 'Nao foi possivel iniciar a separacao')
      }
    },
    podeDevolver (pedido) {
      return ['7', '8'].includes(String(pedido.SITUACAO || '').trim()) && Number(pedido.TOTAL_ETIQUETAS || 0) === 0
    },
    async devolverPedido (pedido) {
      if (!this.podeDevolver(pedido)) return

      const confirmar = await this.$bvModal.msgBoxConfirm(`Devolver o pedido ${pedido.N_VENDA || pedido.SEQUENCIA} para o vendedor?`, {
        title: 'Devolver Pedido',
        okTitle: 'SIM, DEVOLVER',
        cancelTitle: 'CANCELAR',
        okVariant: 'warning',
        centered: true
      })
      if (!confirmar) return

      try {
        this.carregando = true
        await this.$http.post('/api/protected/separacao-vendas/devolver', {
          pedidoId: pedido.SEQUENCIA,
          usuario: window.localStorage.getItem('login')
        })
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Pedido devolvido para o vendedor.')
        await this.carregarPedidos()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err || 'Nao foi possivel devolver o pedido')
      } finally {
        this.carregando = false
      }
    },
    selecionarPedido (pedido) {
      this.selectedPedidoId = pedido.SEQUENCIA
    },
    rowClass (item) {
      if (!item) return ''
      return item.SEQUENCIA === this.selectedPedidoId ? 'table-primary' : ''
    },
    formatarQuant (valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
    },
    formatarData (valor) {
      return valor ? new Date(valor).toLocaleDateString('pt-BR') : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/movimentos/pedidovenda/PedidoVendaSeparacaoWeb.vue